export default __webpack_public_path__ + "static/media/werise-horizontal.267a3ff8.svg";